import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';

export default styled.div`
  ${Constants.PopupMaxHeight}
  overflow: auto;
`;
